import { Modal } from "components";
import { ButtonPrimary } from "components/Atoms/Button";
import SignModal, { SignValue } from "eSignLanding/SignModal";
import { getParticipantName } from "eSignLanding/utils";
import React from "react";

interface Props {
  participant: server.dto.ESignParticipant;

}
export const SignNow = (props: Props) => {
  const [displaySigningModal, setDisplaySigningModal] = React.useState(false);

  const secret = props.participant.paths.landingAbsolute.split("/").pop();

  const onSignClicked = async (signValue: SignValue) => {
    return window.CoreApi.ESignOpen.PlaceSignature(secret, {
      signatureSvg: signValue.svg,
      signatureFileId: signValue.fileGuid
    });
  };

  return <>
    <ButtonPrimary label={RESX.ESign.SignNow} onClick={() => setDisplaySigningModal(true)} />

    {displaySigningModal && <Modal
      isOpen={displaySigningModal}
      handleClose={() => { setDisplaySigningModal(false); }}
      title={RESX.ESign.SignThisDocument}
      width="tiny"
    >
      <SignModal
        secret={secret}
        signeeName={getParticipantName(props.participant)}
        company={props.participant.company}
        onSignClicked={onSignClicked}
        hasFinishedSigning={() => { window.location.reload(); }}
      />
    </Modal>}
  </>
}